import { ReactNode, useState } from 'react';
import { NhanVienContext } from './NhanVienContext';
import { DocumentType } from '../schema';
import { FormMode } from '@/types/form';

interface NhanVienProviderProps {
  children: ReactNode;
}

export const NhanVienProvider = ({ children }: NhanVienProviderProps) => {
  // State
  const [showForm, setShowForm] = useState(false);
  const [formMode, setFormMode] = useState<FormMode>('view');
  const [selectedRow, setSelectedRow] = useState<DocumentType | null>(null);
  const [documentRows] = useState<DocumentType[]>([]);
  const [dependentRows] = useState([]);

  // Handlers
  const handleAdd = () => {
    setFormMode('add');
    setShowForm(true);
  };

  const handleEdit = () => {
    if (selectedRow) {
      setFormMode('edit');
      setShowForm(true);
    }
  };

  const handleDelete = () => {
    if (selectedRow) {
      console.log('Delete clicked', selectedRow);
    }
  };

  const handleCopy = () => {
    if (selectedRow) {
      console.log('Copy clicked', selectedRow);
    }
  };

  const handlePrint = () => {
    if (selectedRow) {
      console.log('Print clicked', selectedRow);
    }
  };

  const handleSearch = () => {
    console.log('Search clicked');
    // Implement search functionality here
  };

  const handleRowClick = (row: DocumentType) => {
    setSelectedRow(row);
  };

  // Context value
  const contextValue = {
    // State
    showForm,
    formMode,
    selectedRow,
    documentRows,
    dependentRows,

    // Actions
    setShowForm,
    setFormMode,
    setSelectedRow,

    // Handlers
    handleAdd,
    handleEdit,
    handleDelete,
    handleCopy,
    handlePrint,
    handleSearch,
    handleRowClick
  };

  return <NhanVienContext.Provider value={contextValue}>{children}</NhanVienContext.Provider>;
};
